var map = {
	"./card.svg": 8177,
	"./covid.svg": 2070,
	"./derm.svg": 1977,
	"./em.svg": 5249,
	"./endo.svg": 233,
	"./ent.svg": 9858,
	"./gast.svg": 6410,
	"./gs.svg": 4065,
	"./id.svg": 468,
	"./neur.svg": 8413,
	"./ob.svg": 4360,
	"./onc.svg": 7239,
	"./oph.svg": 4750,
	"./orth.svg": 6388,
	"./pc.svg": 7776,
	"./ped.svg": 6686,
	"./plas.svg": 4719,
	"./psy.svg": 3865,
	"./pul.svg": 854
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6449;